import { atom } from "recoil";
import { IMercadoAlvo } from "../../commons/types/mercadoAlvo";

export const mercadoAlvoAtom = atom<IMercadoAlvo[]>({
  key: 'mercadoAlvo',
  default: [] as IMercadoAlvo[],
});
